import { render } from "./DynamicRight.vue?vue&type=template&id=2369aa80&scoped=true"
import script from "./DynamicRight.vue?vue&type=script&lang=js"
export * from "./DynamicRight.vue?vue&type=script&lang=js"

import "./DynamicRight.vue?vue&type=style&index=0&id=2369aa80&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2369aa80"]])

export default __exports__